import { buildDownloadData } from '@/pages/intelligence/utils/commonUtils';
import moment from 'moment';

export function getTrueAllDataDownloadExcel(list: any, params: any, allParams: any) {
  const config: any = {};
  const data = list || [];
  if (!data) {
    return;
  }
  // 扁平化数据
  const targetList = [...data];
  let sortedData = [...data];
  // 排序 如果是by_time
  if (Array.isArray(targetList) && allParams?.downlaod_date_method === 'separate') {
    // 首先按照id分组
    const groupedData = targetList.reduce((acc: any, item: any) => {
      if (!acc[item.unified_id]) {
        acc[item.unified_id] = [];
      }
      acc[item.unified_id].push(item);
      return acc;
    }, {});
    sortedData = [];
    // 然后对每个分组按照date降序排序
    sortedData = Object.keys(groupedData).reduce((acc: any, unified_id: any) => {
      const idList = [...groupedData[unified_id]];
      idList?.sort((a: any, b: any) => {
        // 第二优先级：按 time 降序（新时间在前）
        if (b.date !== a.date) return moment(b?.date).diff(moment(a?.date));
        return 0;
      });
      acc.push(...idList);
      return acc;
    }, []);
  }
  // console.log('sortedDatasortedDataList111122222', sortedData);
  // 做一个指标缓存，用于快速判断
  // const metricsCache = {} as any;
  // const metricList = allParams.download_metrics || [];
  // metricList?.forEach((item: string) => {
  //   metricsCache[item] = true;
  // });

  // console.log('targetListtargetList1111metricsCachemetricsCache', metricsCache);

  // stat 页
  const statConfig = [
    {
      title: 'Game Name',
      key: (item: any) => item?.entity_name || '',
    },
    {
      title: 'Publisher Company Name',
      key: (item: any) => item?.publisher || '',
    },
    {
      title: 'Publisher Company HQ Name',
      key: (item: any) => item?.country_name_en || '',
    },
    {
      title: 'Start Date',
      key: (item: any) => (item?.metric_show_start_date !== 'once' ? item?.metric_show_start_date : ''),
    },
    {
      title: 'End Date',
      key: (item: any) => (item?.metric_show_start_date !== 'once' ? item?.metric_show_end_date : ''),
    },
    {
      title: 'Uncertain Date',
      key: (item: any) => (item?.metric_show_start_date === 'once' ? item?.metric_show_end_date : '/'),
    },
    {
      title: 'Metric',
      key: (item: any) => item?.metric_name || '',
    },
    {
      title: 'Data',
      key: (item: any) => item?.metric_value || '',
    },
    {
      title: 'Countributor',
      key: (item: any) => item?.user_name || '',
    },
    {
      title: 'Contributed Time',
      key: (item: any) => moment(item?.fill_time).format('YYYY-MM-DD') || '',
    },
    {
      title: 'Source',
      key: (item: any) => item?.source_type || '',
    },
    {
      title: 'Link',
      key: (item: any) => item?.url || '',
    },
    {
      title: 'Note',
      key: (item: any) => item?.content || '',
    },
  ];

  // console.log('targetListtargetList', targetList);

  config.stat = {
    sheetName: 'Stats',
    style: 'normal',
    data: buildDownloadData(statConfig, sortedData),
  };

  // summary 直接用二维结果写
  config.summary = {
    sheetName: 'Summary',
    style: 'summary',
    data: [
      ['searchKey', params?.keyword || ''],
      ['Date Start', ''],
      ['Date End', ''],
    ],
  };

  return config;
}
